import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {StateService} from '@tva/ng-migration/core/services/state/state.service';
import {CourseManagementService} from "@tva/ng-migration/course-management/services/course-management.service";
import {UnsavedChangesService} from '@tva/ng-migration/shared/services/unsavedChanges.service';
import {NotificationService} from "@tva/ng-migration/uicomponents";
import {CourseManagementEditableBaseComponent} from '../../base/course-management-editable.base.component';

@Component({
  selector: 'app-course-management-add',
  templateUrl: './course-management-add.component.html',
  styleUrls: ['./course-management-add.component.scss']
})
export class CourseManagementAddComponent extends CourseManagementEditableBaseComponent implements OnInit, AfterViewInit, OnDestroy {

  constructor(courseManagementService: CourseManagementService,
    state: StateService, notification: NotificationService, unsavedChanges: UnsavedChangesService) {
    super(courseManagementService, state, notification, unsavedChanges);
  }

  public ngOnInit() {
    super.ngOnInit();
    this.setModalOnLeave();
  }

  public save(): void {
    if (this.validate()) {
      this.courseManagementService.addCourse(this.getCourseData()).subscribe(() => {
        this.notification.showSuccessMessage();
        this.unsavedChanges.saveChanges();
        this.state.go('courseManagement');
      }, ({ error }) => {
        const msg = typeof error === 'string' ? error : "";
        this.notification.showErrorMessage(msg)
      }, () => {
        this.isLoading = false;
      });
    }
  }
}

